<template>
  <div class="ma-2">
    <v-data-table
      :headers="headers"
      :items="itens"
      :options.sync="options"
      :server-items-length="totalItens"
      :loading="loading"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50, 100],
        showFirstLastPage: true,
        itemsPerPageText: 'Itens por página',
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus'
      }"
      @page-count="pageCount = $event">
        <template v-slot:top>
          <v-form @submit="pesquisar()" v-on:submit.prevent>
            <v-container fluid>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select clearable v-model="pesquisa.cc_fil" label="Empresa" placeholder="" :items="filiais" item-text="cc_fil" item-value="cc_fil"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-text-field clearable v-model="pesquisa.dt_fat_i_formatada" v-mask="mascaraData" label="Data início" placeholder="" @blur="pesquisa.dt_fat_i = parseDate(pesquisa.dt_fat_i_formatada)"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-text-field clearable v-model="pesquisa.dt_fat_f_formatada" v-mask="mascaraData" label="Data fim" placeholder="" @blur="pesquisa.dt_fat_f = parseDate(pesquisa.dt_fat_f_formatada)"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-checkbox v-model="pesquisa.bl_sin_man" label="Não sincronizados" value="false"></v-checkbox>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                  <v-btn depressed outlined type="submit" color="primary">pesquisar</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </template>
        <template v-slot:item.vl_fat="{ item }">
            {{ moeda(item.vl_fat) }}
        </template>
        <template v-slot:item.tx_fat_dt_emi="{ item }">
            {{ getDataEmissao(item) }}
        </template>
        <template v-slot:item.cc_fat="{ item }">
            {{ item.cc_fat }} <v-chip small v-if="item.st_fat == 'XA'" v-on="on" color="error">cancelada</v-chip>
        </template>
        <template v-slot:item.cliente="{ item }">
            {{(item.cliente != undefined) ? item.cliente.cc_cli_ins_fed : ''}}
            <span v-if="item.cliente === undefined">-</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab color="primary" v-on="on" @click="ver(item)" class="mr-1">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
            </template>
            <span>Ver</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab v-on="on" :color="`${item.bl_sin_man ? 'primary' : '#E8F5E9'}`" @click="tratarSincronia(item)">
                  <v-icon>mdi-sync-circle</v-icon>
                </v-btn>
            </template>
            <span>{{ `${item.bl_sin_man ? 'Desmarcar sincronizado' : 'Marcar como sincronizado'}` }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" persistent max-width="500" scrollable :key="idModal">
        <v-card>
          <v-card-title>
            Detalhes
          </v-card-title>
          <v-card-text class="pt-2">

            <v-card class="mb-2">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Número</th>
                      <th>Valor</th>
                      <th>Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ itemSelecionado.cc_fat }}</td>
                      <td>{{ moeda(itemSelecionado.vl_fat) }}</td>
                      <td>{{ formatDate(itemSelecionado.dt_fat) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>

            <v-card v-if="itemSelecionado.cliente != undefined" class="mb-2">
              <v-simple-table>
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>Nome</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ itemSelecionado.cliente.cc_cli_ins_fed }}</td>
                    <td>{{ itemSelecionado.cliente.nm_cli }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>

            <v-card class="mb-2" v-if="itemSelecionado.pagamentos != undefined && itemSelecionado.pagamentos.length > 0">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th>Valor</th>
                      <th>Parcelas</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item  in itemSelecionado.pagamentos" :key="item.id_reg">
                      <td>{{ item.ds_pgt }}</td>
                      <td>{{ moeda(item.vl_pgt) }}</td>
                      <td>{{ item.cc_prz }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>

            <v-card class="mb-2">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th align="right" width="40">Vl. Unitário</th>
                      <th align="right" width="40">QTD</th>
                      <th align="right" width="40">Desc</th>
                      <th align="right">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item  in itemSelecionado.itens" :key="item.id_reg">
                      <td>{{ item.cc_psr }}</td>
                      <td align="right">{{ moeda(item.vl_fat_ite_uni) }}</td>
                      <td align="right">{{ item.qt_fat_ite }}</td>
                      <td align="right">{{ moeda(item.vl_fat_ite_des) }}</td>
                      <td align="right">{{ moeda(item.vl_fat_ite_tot) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>

            <!--v-card flat class="mt-2">
                <v-btn block>
                  Fazer Download do XML
                  <v-icon right @click="fazerDownloadItem()">mdi-file-download</v-icon>
                </v-btn>
            </v-card-->

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed @click="dialog = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>
<script>
  import lodash from 'lodash'
  import { moeda } from '../../utils.js'
  export default {
    name: 'NaoFiscal',
    data () {
      return {

        /** atributos da paginacao */
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        totalItens: 0,
        itens: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Empresa', value: 'cc_fil', sortable:false, width: 70 },
          { text: 'Emissão', value: 'tx_fat_dt_emi', sortable:false, width:80},
          { text: 'Cliente', value: 'cliente', sortable:false, width: 80 },
          { text: 'Valor', value: 'vl_fat', sortable:false, width:70, align: 'right'},
          { text: 'Número', value: 'cc_fat', sortable:false },
          { text: 'Pedido', value: 'cc_ped', sortable:false, width:200 },
          { text: '', value: 'action', sortable:false, width: 160, align: 'right' },
        ],

        /** atributos da pesquisa*/
        pesquisa: {
          cc_fil: undefined,
          dt_fat_i: undefined,
          dt_fat_i_formatada: undefined,
          dt_fat_f: undefined,
          dt_fat_f_formatada: undefined,
          bl_sin_man: undefined,
        },
        mascaraData: '##/##/####',

        filiais: [],

        /** atributos da visualização do item */
        dialog: false,
        itemSelecionado: {},
        idModal: 1

      }
    },

    watch: {
      options: {
        handler () {
          this.getDataFromApi()
            .then(data => {
              this.itens = data.items
              this.totalItens = data.total
              this.pageCount = data.totalPages
            })
        },
        deep: true,
      },

    },

    mounted () {
      
      this.getDataFromApi()
        .then(data => {
          this.itens = data.items
          this.totalItens = data.total
        })

      this.populaFiliais()

    },

    created(){
      this.$vuetify.goTo(0)
    },

    methods: {

      pesquisar() { 
        this.page = 1
        this.getDataFromApi()
          .then(data => {
            this.itens = data.items
            this.totalItens = data.total
          })
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },


      populaFiliais() {
        this.$store.dispatch('obterFiliais', {}).then(resp => {
          this.filiais = resp.data.content
        }).catch(err => {
          console.log(err)
        })
      },

      getDataEmissao(item) { 
        let dataArr = item.dt_fat.split('-')
        return `${dataArr[2]}/${dataArr[1]}/${dataArr[0]}`
      },

      ver(item) {
        this.idModal = Math.random(1000)
        this.itemSelecionado = item
        this.dialog = true
      },

      tratarSincronia(item) {
        this.$store.dispatch(item.bl_sin_man ? 'anularRecebimento' : 'marcarComoRecebido', item).then(() => {
          item.bl_sin_man = !item.bl_sin_man
        }).catch(err => {
          console.log(err)
        })
      },

      moeda(valor){
        return moeda(valor)
      },

      getDataFromApi () {

        this.loading = true

        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {

          // eslint-disable-next-line no-unused-vars
          const { sortBy, sortDesc, page, itemsPerPage } = this.options

          let params = {
            page: page-1,
            size: itemsPerPage === -1 ? 999999999 : itemsPerPage
          };

          let filtro = lodash.omitBy(Object.assign(params, this.pesquisa), o => !o)

          this.$store.dispatch('pesquisaFaturaNaoFiscal', filtro).then( resp => {

            this.loading = false

            let items        = resp.data.content
            const total      = resp.data.totalElements
            const totalPages = resp.data.totalElements

            resolve( { items, total, totalPages } )

          }).catch( err => {
            console.log(err)
          })

        })
      }
    },
  }
</script>